import React, { useEffect, useState, useContext } from 'react';
import './DashboardType11Arka.scss';
import TrackingItemBox from "./DashboardItems/TrackingItemBox";
import DynaSelectBox from "../../../../Components/A13/DynaView/DynaSelectBox";
import DynaInput from "../../../../Components/A13/DynaView/DynaInput";
import { toast } from "react-toastify";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { SetPrintDataContext } from "../../../index";
import { useNavigate } from "react-router-dom";

const DashboardArkaManager = ({ data }) => {
  const [sendData, setSendData] = useState({
    request: "phaseShiftOrSuspend",
    phaseId: "",
    projectId: "",
    select: "shift",
    days: "",
  });

  const setprint = useContext(SetPrintDataContext);
  const navigateTo = useNavigate();

  const [currentTab, setCurrentTab] = useState(1);
  const [phaseArray, setPhaseArray] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [versionArray, setVersionArray] = useState([]);
  const [printData, setPrintData] = useState({
    version: "",
    printType: "",
  });

  const printType = [
    { label: "فرم تحلیل گزارش", value: "reportAnalysisForm" },
    { label: "فرم تحلیل نیازها", value: "needsAnalysisForm" },
    { label: "فهرست زیر سیستم ها", value: "listOfSubsystems" },
    { label: "نمودار ER", value: "ErDiagram" },
    { label: "مشخصات رابطه ها", value: "characteristicsOfRelationships" },
    { label: "رابطه ها", value: "relationships" },
    { label: "دامنه ها", value: "domains" },
    { label: "فهرست ورژن ها", value: "listOfVersions" },
    { label: "نمایش فرم", value: "showForm" },
    { label: "فرم QA", value: "QAForm" },
    { label: "فهرست API", value: "listOfAPIs" },
    { label: "فهرست تحلیل ها", value: "analysisList" },
    { label: "فهرست فرم ها", value: "listOfForms" },
  ];

  useEffect(() => {
    const project = data?.managerProjects.find((item) => item.value === projectId);
    if (project) {
      setVersionArray(project.options);
      setPrintData((prev) => ({ ...prev, version: "" }));
    } else {
      setVersionArray([]);
      setPrintData((prev) => ({ ...prev, version: "" }));
    }
  }, [projectId]);

  useEffect(() => {
    if (sendData?.projectId !== "") {
      const filtered = data?.managerProjects.filter((item) => {
        return item.value === sendData.projectId
      });
      if (filtered[0].options.length > 0) {
        setPhaseArray(filtered[0].options);
        setSendData({ ...sendData, phaseId: "" });
      } else {
        setPhaseArray([]);
        setSendData({ ...sendData, phaseId: "" });
      }
    }
  }, [sendData?.projectId]);

  const handlePrint = () => {
    if (projectId === "") {
      return toast.error("پروژه را انتخاب کنید");
    }
    if (printData?.printType === "") {
      return toast.error("نوع پرینت را انتخاب کنید");
    }

    const type = printData?.version === "" ? "project" : "version";
    const id = printData?.version === "" ? projectId : printData?.version;

    _axios.get(prefixUrl() + `/arkaPrints/?request=documentPrint&type=${type}&id=${id}`)
      .then((response) => {
        if (response.data.status) {
          const documentPrint = response?.data?.data;
          setprint({
            type: printData?.printType,
            data: documentPrint[printData.printType]
          });
          navigateTo("/factorprint");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error("خطا در دریافت اطلاعات پرینت");
      });
  };

  const dataHandler = () => {
    if (sendData?.projectId === "") {
      return toast.error("نام پروژه انتخاب کنید");
    }
    if (sendData?.phaseId === "") {
      return toast.error("نام فاز انتخاب کنید");
    }
    if (sendData?.select === "shift" && sendData?.days === "") {
      return toast.error("تعداد روز را وارد کنید");
    }

    _axios.post(prefixUrl() + "/customFunctions/", sendData).then((response) => {
      if (response.data.status) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    });
  };

  return (
    <section className={"main-DashboardType11Arka DashboardArkaManager"}>
      <TrackingItemBox data={data} />

      <div className={"sec-left-item"}>
        <div className={"row-tab-change"}>
          <h6 onClick={() => setCurrentTab(1)}
            style={currentTab === 1 ? { backgroundColor: "#FFBD35" } : { backgroundColor: "#FFFFFF" }}>پرینت</h6>
          <h6 onClick={() => setCurrentTab(2)}
            style={currentTab === 2 ? { backgroundColor: "#FFBD35" } : { backgroundColor: "#FFFFFF" }}>شیفت فاز</h6>
        </div>

        {/* تب پرینت */}
        {currentTab === 1 && (
          <div className={"sec-left-item-box"}>
            <DynaSelectBox
              options={data?.managerProjects}
              hasFilter={false}
              label="نام پروژه"
              className="solid-dyna-input"
              value={projectId}
              onChange={(data) => setProjectId(data?.value)}
            />
            <DynaSelectBox
              options={versionArray}
              hasFilter={false}
              label="نام ورژن"
              className="solid-dyna-input"
              value={printData?.version}
              onChange={(data) => setPrintData({ ...printData, version: data?.value })}
            />
            <DynaSelectBox
              options={printType}
              hasFilter={false}
              label={"نوع پرینت"}
              className={"solid-dyna-input"}
              value={printData?.printType}
              onChange={(data) => setPrintData({ ...printData, printType: data?.value })}
            />
            <div className={"sec-left-but"}>
              <button onClick={handlePrint}>پرینت</button>
            </div>
          </div>
        )}

        {/* تب شیفت فاز */}
        {currentTab === 2 && (
          <div className={"sec-left-item-box"}>
            <DynaSelectBox options={data?.managerProjects}
              hasFilter={false}
              label={"نام پروژه"}
              className={"solid-dyna-input"}
              value={sendData?.projectId}
              onChange={(data) => setSendData({ ...sendData, projectId: data?.value })}
            />
            <DynaSelectBox options={phaseArray}
              hasFilter={false}
              label={"نام فاز"}
              className={"solid-dyna-input"}
              value={sendData?.phaseId}
              onChange={(data) => setSendData({ ...sendData, phaseId: data?.value })}
            />
            <DynaSelectBox
              options={[
                { value: "shift", label: "شیفت" },
                { value: "suspend", label: "معلق" },
              ]}
              hasFilter={false}
              label={"وضعیت"}
              className={"solid-dyna-input"}
              value={sendData?.select}
              onChange={(data) => setSendData({ ...sendData, select: data?.value })}
            />

            {sendData?.select === "shift" &&
              <DynaInput label={"تعداد روز"}
                name={"days"}
                className={"solid-dyna-input"}
                placeholder={"تعداد روز را وارد کنید"}
                value={sendData?.days}
                type={"text"}
                setDataFromComponent={(data) => {
                  setSendData({ ...sendData, ...data })
                }}
              />
            }

            <div className={"sec-left-but"}>
              <button onClick={dataHandler}>ثبت</button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DashboardArkaManager;